import React from 'react';
import styled from 'styled-components';
import {
  Page,
  SkeletonBodyText,
  SkeletonThumbnail
} from '@superops/ui-design-system';

import Loading from '@nile/components/src/Svg/AnimatedSvg/Loading.svg';

const LoaderWrapper = styled.div`
  .Polaris-SkeletonBodyText:after {
    margin: 5px 0;
  }
  .Superops-Page-Header {
    .Polaris-SkeletonBodyText__SkeletonBodyTextContainer {
      width: 30%;
    }
  }
`;

const HeaderLoading = styled.div`
  background: #ffffff;
  height: 95px;
  padding-left: 55px;
  .Polaris-SkeletonBodyText__SkeletonBodyTextContainer {
    margin-left: 20px;
    width: 30%;
  }
`;

const LoadingWrapper = styled.div`
  svg {
    height: 80px;
    width: 80px;
  }
`;

const InvoiceQuoteLoader = () => {
  return (
    <LoaderWrapper className="full-height flex fcol">
      <HeaderLoading className="w100 bg-white mb20 flex actr g20">
        <SkeletonThumbnail size="small" />
        <SkeletonBodyText size="small" lines={1} />
      </HeaderLoading>
      <div className="w100 f11">
        <Page
          variant="primary"
          contentHeight="70px"
          title={<SkeletonBodyText size="small" lines={1} />}
        >
          <div className="w100 fhp flex">
            <LoadingWrapper className="fhp w100 flex actr jctr">
              <Loading />
            </LoadingWrapper>
          </div>
        </Page>
      </div>
    </LoaderWrapper>
  );
};

export default InvoiceQuoteLoader;
